<template>
  <template v-if="isLoaded">
    <div class="menu-view">
      <HelpCard v-on:close="$emit('close')"></HelpCard>
    </div>
  </template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"
import HelpCard from "@/components/HelpCard.vue"

@Options({
  components: {
    HelpCard, TextButton, PatreonButton
  },
  props: {
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class HelpMenu extends Vue {
  isLoaded = false
}
</script>

<style scoped lang="scss">

.menu-view {
  //max-width: $full-page-width;
  height: 100vh;

  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    "t"
    "t";
  grid-gap: 20px;

  @media screen and (max-width: $mobile-width){
    grid-template-areas:
      "t"
      "t";
    margin: 0;
  }
}

.help-card {
  margin: 20px auto;
}
</style>
